const checkDate = (value: string, type: string) => {
  const regExp = /\d\d.\d\d.\d\d\d\d/;

  const isDateType = type === 'date';

  return !isDateType || (isDateType && (regExp.test(value) || !value));
};

export { checkDate };
